import React, { useEffect } from "react"
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import { useHistory } from "react-router-dom";
import SyslogSettingsSection from "./SyslogSettingsSection";


const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Syslog Events Identification",
        redirectTo: "/syslog-settings",
    }
]

function SyslogSettingsPage({ userCapability }) {

    const history = useHistory();

    //Hide pages with capability = -1, and even if the url is copied then logout the user directly
    //#region Set User Capabilities
    const checkCapability = async () => {
        try {
            if (userCapability) {
                const capability = userCapability.find(item =>
                    item.component === "syslogeventsidentification" && item.type === "page")?.permission;
                if (capability === -1) {
                    sessionStorage.removeItem('access_token');
                    window.location.reload();
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        checkCapability();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    useEffect(() => {
        layoutService.setPageTitle('Syslog Events Identification')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes />
            <SyslogSettingsSection />
        </>
    );
}


function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default withMainLayout(connect(mapStateToProps)(SyslogSettingsPage));
